import type { ChangeEvent } from "react";
import { Switch, type SwitchProps } from "@mui/material";
import { styled } from "@mui/material/styles";

type Props = SwitchProps & {
  readOnly: boolean;
};

const defaultProps: Partial<Props> = {
  readOnly: false,
};

function CustomSwitch(props: Props) {
  const { readOnly, onChange, ...rest } = props;

  function handleChange(
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) {
    if (!readOnly && onChange) onChange(event, checked);
  }

  return render();

  function render() {
    return (
      <Styles readOnly={readOnly}>
        <Switch {...rest} onChange={handleChange} />
      </Styles>
    );
  }
}

CustomSwitch.defaultProps = defaultProps;
export { CustomSwitch };

const Styles = styled("div")<{ readOnly: boolean }>`
  ${(props) =>
    props.readOnly &&
    `
      opacity: 0.5;
      pointer-events: none;
    `}

  .MuiSwitch-switchBase {
    :not(.Mui-disabled):not(.Mui-checked) {
      color: #940000;

      + .MuiSwitch-track {
        background-color: #ffc4c4;
        opacity: 1;
      }
    }
  }

  .Mui-checked:not(.Mui-disabled) {
    .MuiSwitch-thumb {
      color: #149600;
    }

    + .MuiSwitch-track {
      background-color: #c7f3bc;
      opacity: 1;
    }
  }

  .Mui-checked.Mui-disabled {
    .MuiSwitch-thumb {
      color: #f5f5f5;
    }
    + .MuiSwitch-track {
      background-color: #e0e0e0;
      opacity: 1;
    }
  }
  
`;
